import {openModal} from 'snippets/_containers/modal/modal';
import {formatMoney} from '@shopify/theme-currency';

const finalSaleTag = 'Final-Sale',
    translations = window.translations,
    localeUrl = window.localeUrl;

export const lineItemCardHtml = async (itemData, lineItemAddedQuantity = 0) => {
    // Populate line item into card
    let lineItemCard = '';

    // Get item image
    let lineItemImage = '';

    if (typeof itemData.image != 'undefined' && itemData.image != '') {
        lineItemImage = itemData.image;
    } else if(itemData.featured_image.url){
        lineItemImage = itemData.featured_image.url;
    }

    // Get item url
    const lineItemUrl = itemData.url;
    // Get item title
    const lineItemTitle = itemData.product_title;
    // Get item prices
    const lineItemPrice         = formatMoney(itemData.price, theme.moneyWithoutCurrency); // Current Price
    const lineItemOriginalPrice   = formatMoney(itemData.original_price, theme.moneyWithoutCurrency); // Original Price
    let lineItemComparePrice    = '';
    let lineItemComparePriceRaw = null;
    let lineItemVariantTitle = null;
    
    // Get variant title
    if ( itemData?.variant_title != null ) {
        lineItemVariantTitle = itemData.variant_title.replace(' / ', ', ');
    }

    // Get product handle
    const productHandle = itemData.handle;
    // Final Sale Product - Check if the product is final sale or not based on tags
    let isFinalSale = false;

    await fetch(localeUrl+'/products/'+ productHandle +'.js')
        .then(response => response.json())
        .then(product => {
        // get product compare at price max
            product.variants.forEach((value) => {
                if (itemData.id == value.id) {
                    lineItemComparePrice = formatMoney(value.compare_at_price, theme.moneyWithoutCurrency);
                    lineItemComparePriceRaw = value.compare_at_price;
                }
            });
        
            // Get product tags
            product.tags.forEach((value) => {
                if (value == finalSaleTag) {
                    isFinalSale = true;
                    return false;
                }
            });
        })
        .catch(error => {
            console.error(error);
        });

    lineItemCard += '<article class="card card--default card--line-item card--line-item--placeholder">';
    // Image with link
    lineItemCard += '<a tabindex="-1" href='+ lineItemUrl +'>';
    if ( lineItemImage !== null && lineItemImage != '' ) {
        lineItemCard += `
        <picture>
            <source media="(min-width: 1024px)" srcset="${lineItemImage}&width=300 300w, ${lineItemImage}&width=250 250w">
            <source media="(min-width: 601px)" srcset="${lineItemImage}&width=250 250w, ${lineItemImage}&width=180 180w">
            <source srcset="${lineItemImage}&width=180 180w">

            <img class="line-item__image" 
                src="${lineItemImage}&width=250" 
                srcset="${lineItemImage}&width=180 180w, ${lineItemImage}&width=250 250w, ${lineItemImage}&width=300 300w"
                alt="" 
                width="250" 
                height="250" 
                decoding="async" 
                loading="lazy">
        </picture>`;

    }
    lineItemCard += '</a>';
    lineItemCard += '<div class="">';
    // Title
    if ( lineItemTitle.length ) {
        lineItemCard += '<h3 class="card__title">'+ lineItemTitle +'</h3>';
    }

    // Meta
    lineItemCard += '<div class="card__metadata">';
    // Variant Title
    if ( lineItemVariantTitle ) {
        lineItemCard += '<p class="line-item__variant-title">'+ lineItemVariantTitle +'</p>';
    }

    // Quantity
    let lineItemQuantity;
    if ( lineItemAddedQuantity > 0 ) {
        lineItemQuantity = lineItemAddedQuantity;
    }else{
        lineItemQuantity = itemData.quantity;
    }
    lineItemCard += '<p class="line-item__added-quantity">'+ translations.shortQuantity +': '+ lineItemQuantity +'</p>';

    // Prices
    lineItemCard += '<div data-price-wrapper="" class="card__price">';
    if ( lineItemOriginalPrice != lineItemPrice) {
        lineItemCard += '<span class="visually-hidden" data-original-price-text="">Original Price</span>';
        lineItemCard += '<s data-original-price="">'+ lineItemOriginalPrice +'</s>';
    }else if( lineItemComparePriceRaw != null ){
        lineItemCard += '<span class="visually-hidden" data-compare-text="">Regular price</span>';
        lineItemCard += '<s data-compare-price="" class="card__price--sale">'+ lineItemComparePrice +'</s>';
    }
    lineItemCard += '<span data-product-price="" class="card__price--original">'+ lineItemPrice +'</span>';
    lineItemCard += '</div>';

    // Final Sale
    if ( isFinalSale == true ) {
        lineItemCard += '<div class="line-item__final-sale">';
        lineItemCard += '<span>'+ translations.finalSaleLabel +'</span>';
        lineItemCard += '</div>';
    }

    lineItemCard += '</div></div>';

    lineItemCard += '</article>';

    return lineItemCard;
};

// Get current cart information and output as html
export const cartSubtotalUpdate = (cartData) => {

    const _config = {
        cartCountSelector: '.cart__item-count',
        cartCountScreenReader: '.cart__item--count-sr',
        miniCartCountSelector  : '.cart__count'
    };

    // Get number of items in cart
    const cartItemsNum = parseInt(cartData.item_count);
    let cartItemsNumLabel;
    let cartItemsScreenReader;
    
    if (cartItemsNum > 1) {
        cartItemsNumLabel = translations.itemCountOther;
        cartItemsScreenReader = translations.itemCountOther;
    } else {
        cartItemsNumLabel = translations.itemCountOne;
        cartItemsScreenReader = translations.itemCountOne;
    }

    const subTotalLabel = translations.subTotalLabel;

    // Get items subtotal price
    const cartSubtotal = formatMoney(cartData.items_subtotal_price, theme.settingCurrencyFormat);
    const cartSubtotalContainers = document.querySelectorAll('.cart-subtotal__container');
    
    if (cartSubtotalContainers.length) {
        cartSubtotalContainers.forEach(container => {
            container.querySelector('.cart-info__item-count').textContent = `${subTotalLabel} (${cartItemsNum} ${cartItemsNumLabel})`;
            container.querySelector('.cart-info__subtotal').textContent = cartSubtotal;
        });
    }

    // Update cart counts
    const cartCounts = document.querySelectorAll(_config.cartCountSelector);
    const cartCountContainer  = document.querySelector(_config.miniCartCountSelector);
    const cartCountsScreenReader = document.querySelectorAll(_config.cartCountScreenReader);
    if (cartCounts?.length > 0) {
        cartCounts.forEach((cartCount) => {
            cartCount.textContent = cartData.item_count;

            if( cartData.item_count == 0 ) {
                if( cartCountContainer.classList.contains('highlighted-text') ) {
                    cartCountContainer.classList.remove('highlighted-text');
                }
            }
        });
        
        cartCountsScreenReader.forEach((cartCountScreen) => {
            cartCountScreen.textContent = `${cartData.item_count} ${cartItemsScreenReader}`; 
        });
    }
};


document.addEventListener('DOMContentLoaded', () => {

    Shopify.AjaxifyCart = () => {
        
        const _config = {

            // What you might want to change
            addToCartBtnLabel             : translations.addToCart,
            addedToCartBtnLabel           : translations.addingToCart,
            addingToCartBtnLabel          : translations.addingToCart,
            soldOutBtnLabel               : translations.soldOut,
            howLongTillBtnReturnsToNormal : 800, // in milliseconds.
            cartCountSelector             : '.cart__item-count',
            cartCountScreenReader         : '.cart__item--count-sr',
            cartTotalSelector             : '#cart-price',

            // What you will never need to change
            addToCartBtnSelector          : '.btn--add-to-cart--quick',
            addToCartFormSelector         : 'form[action="/cart/add"]',
            shopifyAjaxAddURL             : localeUrl+'/cart/add.js',
            shopifyAjaxCartURL            : localeUrl+'/cart.js',
            productPriceWrapper           : '[data-price-wrapper]',
            productComparePrice           : '[data-compare-price]',
            productQuantityInput          : 'input[name="quantity"]',

            // Cart Confirmation Modal configs
            cartModal                     : '.modal--cart-confirmation',
            cartModalMessage              : '.cart-confirmation__message',
            cartModalItem                 : '.cart-confirmation__item',
            cartModalCartInfo             : '.cart-subtotal__container',
        };

        // We need some feedback when adding an item to the cart.
        // Here it is.
        const _showFeedback = (itemData) => {

            document.querySelector(_config.cartModalMessage).innerHTML = translations.modalSuccessMessage + ' <svg class="icon icon__check--circle"><use xlink:href="#icon-check--circle"></use></svg>';

            // Get product quantity added to cart
            const lineItemAddedQuantity = document.querySelector(_config.addToCartFormSelector).querySelector(_config.productQuantityInput).value;

            // Get Added Item info and append to the modal
            lineItemCardHtml(itemData, lineItemAddedQuantity).then((lineItemCardHtml) => {
                document.querySelector(_config.cartModalItem).innerHTML = lineItemCardHtml;

                // Open the modal after the item is added
                const modal = document.querySelector(_config.cartModal);
                openModal(modal);
            });
        };

        const _setText = function(button, label) {
            if (button?.children.length) {
                button.children.forEach(function(child) {
                    if (child.textContent.trim() !== '') {
                        child.textContent = label;
                    }
                });
            } else if(button) {
                button.textContent = label;
            }
        };

        var _init = function() {
            // SPRING RATE CALCULATOR
            var productForm = document.querySelector('.js-product-form'),
                additionalProductPopup = document.querySelector('.additional-product-calulator-popup-wrapper'),
                additionalProductPopupClose = document.querySelector('.additional-product-calulator-popup-wrapper .close'),
                continueProductAddingBtns = document.querySelectorAll('.additional-product-popup-no-thanks a'),
                calculatorInputs = document.querySelectorAll('.additional-product-calulator-popup-wrapper .field-item > input'),
                calculatorInputsPage = document.querySelectorAll('.page-additional-product-calculator .field-item > input'),
                getAnAdditionalProductBtn = document.querySelector('.additional-product-popup-calculate-btn:not(.page-additional-product-popup-calculate-btn)'),
                PageGetAnAdditionalProductBtn = document.querySelector('.page-additional-product-popup-calculate-btn'),
                weigthSwitcher = document.querySelector('.additional-product-calulator-popup-wrapper .weight-switch input'),
                lengthSwitcher = document.querySelector('.additional-product-calulator-popup-wrapper .length-switch input'),
                PageWeigthSwitcher = document.querySelector('.page-additional-product-calculator .weight-switch input'),
                PageLengthSwitcher = document.querySelector('.page-additional-product-calculator .length-switch input'),
                additionalProductMainSelectOptions = document.querySelectorAll('.additional-product-form__single-variant-select option'),
                formContainer = document.querySelector('.calculator-container'),
                formContainerPage = document.querySelector('.page-additional-product-popup-wrapper'),
                additionalProductFinalContainer = document.querySelector('.additional-product-container'),
                additionalProductFinalContainerPage = document.querySelector('.page-additional-product-popup'),
                addProductsBtn = document.querySelector('.additional_sls_product .additional-product-popup-add-btn'),
                addStandardProductsBtn = document.querySelector('.additional_standard_product .additional-product-popup-add-btn'),
                addProductsBtnPage = document.querySelector('.additional-product-popup-add-btn-page'),
                diffPageLink = document.querySelector('.additional-product-container .additional-product-info-rte a'),
                closeCalculatorPage = document.querySelector('.page-additional-product-popup .close'),
                noThanksLinkPage = document.querySelector('.page-additional-product-popup .additional-product-popup-no-thanks a'),
                optionStandard,
                mainSKU,
                mainId,
                optionStroke;
            
            if (document.getElementById('AdditionalProductJson') != null) {
                var additionalProductJson = document.getElementById('AdditionalProductJson').innerHTML;
            }
            
            if (document.getElementById('AdditionalSLSProductJson') != null) {
                var additionalSLSProductJson = document.getElementById('AdditionalSLSProductJson').innerHTML;
            }
            
            
            if (closeCalculatorPage != null) {
                closeCalculatorPage.addEventListener('click', function (event) {
                    this.closest('.page-additional-product-popup-wrapper').classList.remove('show');
                });
            }
            
            if (noThanksLinkPage != null) {
                noThanksLinkPage.addEventListener('click', function (event) {
                    this.closest('.page-additional-product-popup-wrapper').classList.remove('show');
                });
            }
            
            if (productForm != null) {

                productForm.addEventListener('submit', function (event) {
                    // if (this.classList.contains('product-form--single-shocks')) {
                    //     event.preventDefault();

                    //     var currentOption = this.querySelector('[name="id"]');
                    //     optionStandard = currentOption.options[currentOption.selectedIndex].getAttribute('data-option-1');
                    //     optionStroke = currentOption.options[currentOption.selectedIndex].getAttribute('data-option-2').split('x')[1];
                    //     mainSKU = currentOption.options[currentOption.selectedIndex].getAttribute('data-sku');
                    //     mainId = currentOption.value;
                    //     openAdditionalProductPopup(optionStandard, optionStroke, mainSKU, mainId);
                    // }
                });
            }
            
            if (additionalProductPopupClose != null) {
                additionalProductPopupClose.addEventListener('click', function () {
                    this.closest('.additional-product-calulator-popup-wrapper').classList.remove('show');
                    formContainer.classList.add('show');
                    additionalProductFinalContainer.classList.remove('show');
                    calculatorInputs.forEach(function (item) {
                        item.value = '';
                        item.classList.remove('error-input');
                        item.closest('.field-item').querySelector('.error').classList.remove('show');
                    });
                    weigthSwitcher.checked = false;
                    lengthSwitcher.checked = false;
                    getAnAdditionalProductBtn.setAttribute('data-weight-unit', 'lbs');
                    getAnAdditionalProductBtn.setAttribute('data-length-unit', 'in');
            
                    if (productForm != null) {
                        // productForm.submit();
                        window.location.href='/cart';
                    }
                });
            }
            
            if (continueProductAddingBtns.length) {
                continueProductAddingBtns.forEach(function (item) {
                    item.addEventListener('click', function (event) {
                        if (this.closest('.additional-product-calulator-popup-wrapper') != null) {
                            this.closest('.additional-product-calulator-popup-wrapper').classList.remove('show');
                        }
                        if (productForm != null) {
                            productForm.submit();
                        }
                    });
                });
            }
            
            if (diffPageLink != null) {
                diffPageLink.addEventListener('click', function (event) {
                    var _this = this;
                    event.preventDefault();
                    Shopify.addItem(this.closest('.additional-product-calulator-popup-wrapper').getAttribute('data-main-product-id'), 1);
                    setTimeout(function () {
                        window.location.href = _this.getAttribute('href');
                    }, 300);
                });
            }
            
            if (getAnAdditionalProductBtn != null) {
                getAnAdditionalProductBtn.addEventListener('click', function (event) {
                    var mainSKU = this.closest('.additional-product-calulator-popup-wrapper').getAttribute('data-main-product-sku');
                    var mainId = this.closest('.additional-product-calulator-popup-wrapper').getAttribute('data-main-product-id');
                    var standard = this.closest('.additional-product-calulator-popup-wrapper').getAttribute('data-standard');
                    var stroke = this.closest('.additional-product-calulator-popup-wrapper').getAttribute('data-stroke');
                    var weightUnit = this.getAttribute('data-weight-unit');
                    var lengthUnit = this.getAttribute('data-length-unit');
                    var weightInput = this.closest('.additional-product-calulator-popup-wrapper').querySelector('#RiderWeight');
                    var lengthInput = this.closest('.additional-product-calulator-popup-wrapper').querySelector('#RearWheelTravel');

                    getAnAdditionalProduct(standard, stroke, weightUnit, lengthUnit, weightInput.value, lengthInput.value, mainSKU, mainId);
                });
            }
            
            if (PageGetAnAdditionalProductBtn != null) {
                PageGetAnAdditionalProductBtn.addEventListener('click', function (event) {
                    var currentOption = productForm.querySelector('[name="id"]');
                    var standard = this.closest('.page-additional-product-calculator').querySelector('#pageCalculatorStandard').value;
                    var strokeValue = this.closest('.page-additional-product-calculator').querySelector('#pageCalculatorStroke').value;
                    if (strokeValue.indexOf('mm') != -1) {
                        var stroke = +strokeValue.split('m')[0];
                    } else {
                        var stroke = +strokeValue.split('"')[0];
                    }
                    var eyeToEye = this.closest('.page-additional-product-calculator').querySelector('#pageCalculatorEyeToEye').value;
                    var weightUnit = this.getAttribute('data-weight-unit');
                    var lengthUnit = this.getAttribute('data-length-unit');
                    var weightInput = this.closest('.page-additional-product-calculator').querySelector('#pageCalculatorRiderWeight');
                    var lengthInput = this.closest('.page-additional-product-calculator').querySelector('#pageCalculatorRearWheelTravel');
                    if (currentOption.querySelector('option[data-option-1="' + standard + '"][data-option-2="' + eyeToEye + '"][data-option-3="' + strokeValue + '"]') != null) {
                        var mainSKU = currentOption.querySelector('option[data-option-1="' + standard + '"][data-option-2="' + eyeToEye + '"][data-option-3="' + strokeValue + '"]').getAttribute('data-sku');
                        var mainId = currentOption.querySelector('option[data-option-1="' + standard + '"][data-option-2="' + eyeToEye + '"][data-option-3="' + strokeValue + '"]').getAttribute('value');
                        getAnAdditionalProductPage(standard, stroke, weightUnit, lengthUnit, weightInput.value, lengthInput.value, mainSKU, mainId);
                        document.querySelector('.page-additional-product-calculator .adding-error').classList.remove('show');
                    } else {
                        document.querySelector('.page-additional-product-calculator .adding-error').classList.add('show');
                    }
                });
            }
            
            if (calculatorInputs.length) {
                calculatorInputs.forEach(function (item) {
                    item.addEventListener('input', function (event) {
                        document.querySelector('.additional-product-calulator-popup-wrapper .adding-error').classList.remove('show');
                        if (item.value != '') {
                            item.classList.remove('error-input');
                            item.closest('.field-item').querySelector('.error').classList.remove('show');
                        }
                    });
                });
            }
            
            if (calculatorInputsPage.length) {
                calculatorInputsPage.forEach(function (item) {
                    item.addEventListener('input', function (event) {
                        document.querySelector('.additional-product-calulator-popup-wrapper .adding-error').classList.remove('show');
                        if (item.value != '') {
                            item.classList.remove('error-input');
                            item.closest('.field-item').querySelector('.error').classList.remove('show');
                        }
                    });
                });
            }
            
            if (weigthSwitcher != null) {
                weigthSwitcher.addEventListener('change', function (event) {
                    if (getAnAdditionalProductBtn != null) {
                        if (this.checked) {
                            getAnAdditionalProductBtn.setAttribute('data-weight-unit', 'kg');
                        } else {
                            getAnAdditionalProductBtn.setAttribute('data-weight-unit', 'lbs');
                        }
                    }
                });
            }
            
            if (lengthSwitcher != null) {
                lengthSwitcher.addEventListener('change', function (event) {
                    if (getAnAdditionalProductBtn != null) {
                        if (this.checked) {
                            getAnAdditionalProductBtn.setAttribute('data-length-unit', 'mm');
                        } else {
                            getAnAdditionalProductBtn.setAttribute('data-length-unit', 'in');
                        }
                    }
                });
            }
            
            if (PageWeigthSwitcher != null) {
                PageWeigthSwitcher.addEventListener('change', function (event) {
                    if (PageGetAnAdditionalProductBtn != null) {
                        if (this.checked) {
                            PageGetAnAdditionalProductBtn.setAttribute('data-weight-unit', 'kg');
                        } else {
                            PageGetAnAdditionalProductBtn.setAttribute('data-weight-unit', 'lbs');
                        }
                    }
                });
            }
            
            if (PageLengthSwitcher != null) {
                PageLengthSwitcher.addEventListener('change', function () {
                    if (PageGetAnAdditionalProductBtn != null) {
                        if (this.checked) {
                            PageGetAnAdditionalProductBtn.setAttribute('data-length-unit', 'mm');
                        } else {
                            PageGetAnAdditionalProductBtn.setAttribute('data-length-unit', 'in');
                        }
                    }
                });
            }
            
            function openAdditionalProductPopup(optionStandard, optionStroke, mainSKU, mainId) {
                if (additionalProductPopup != null) {
                    additionalProductPopup.classList.add('show');
                    additionalProductPopup.setAttribute('data-standard', optionStandard);
                    additionalProductPopup.setAttribute('data-main-product-sku', mainSKU);
                    additionalProductPopup.setAttribute('data-main-product-id', mainId);
                    additionalProductPopup.setAttribute('data-stroke', optionStroke);
                }
            }
            
            Shopify.queue = [];
            
            function getAnAdditionalProduct(standard, stroke, weightUnit, lengthUnit, weightValue, lengthValue, mainSKU, mainId) {
                var calculate = true;
                var nStroke = 0;
                if (calculatorInputs.length) {
                    calculatorInputs.forEach(function (item) {
                        if (item.value == '') {
                            item.classList.add('error-input');
                            item.closest('.field-item').querySelector('.error').classList.add('show');
                            calculate = false;
                        }
                    });
                }

                if (stroke.includes('"')) {
                    nStroke = parseInt(stroke.replace('"', ''));
                } else if (stroke.includes('mm')) {
                    nStroke = parseInt(stroke.replace('mm', ''));
                } else {
                    nStroke = parseInt(stroke);
                }
            
                if (calculate) {
                    var coilSpringWeight, currentVariantPrice, currentVariantTitle, currentVariantSku, currentVariantId;
                    var currentStandardVariantPrice, currentStandardVariantTitle, currentStandardVariantSku, currentStandardVariantId;
                    if (standard == 'Metric' || standard == 'Metric Trunnion') {
                        if (weightUnit == 'lbs' && lengthUnit == 'in') {
                            coilSpringWeight = (weightValue / 165) * 400 * (lengthValue / ((nStroke / 25.4) * (nStroke / 25.4)));
                        } else if (weightUnit == 'kg' && lengthUnit == 'in') {
                            coilSpringWeight = ((weightValue * 2.205) / 165) * 400 * (lengthValue / ((nStroke / 25.4) * (nStroke / 25.4)));
                        } else if (weightUnit == 'kg' && lengthUnit == 'mm') {
                            coilSpringWeight = ((weightValue * 2.205) / 165) * 400 * ((lengthValue / 25.4) / (((nStroke / 25.4) * (nStroke / 25.4))));
                        } else if (weightUnit == 'lbs' && lengthUnit == 'mm') {
                            coilSpringWeight = ((weightValue) / 165) * 400 * ((lengthValue / 25.4) / (((nStroke / 25.4) * (nStroke / 25.4))));
                        }
                    } else if (standard == 'Imperial') {
                        if (weightUnit == 'lbs' && lengthUnit == 'in') {
                            coilSpringWeight = (weightValue / 165) * 400 * (lengthValue / ((nStroke * nStroke)));
                        } else if (weightUnit == 'kg' && lengthUnit == 'in') {
                            coilSpringWeight = ((weightValue * 2.205) / 165) * 400 * (lengthValue / ((nStroke * nStroke)));
                        } else if (weightUnit == 'kg' && lengthUnit == 'mm') {
                            coilSpringWeight = ((weightValue * 2.205) / 165) * 400 * ((lengthValue / 25.4) / ((nStroke * nStroke)));
                        } else if (weightUnit == 'lbs' && lengthUnit == 'mm') {
                            coilSpringWeight = ((weightValue) / 165) * 400 * ((lengthValue / 25.4) / ((((nStroke * nStroke)))));
                        }
                    }
            
                    coilSpringWeight = Math.round(coilSpringWeight / 50) * 50;
                    var additionalProductJsonObj = JSON.parse(additionalProductJson);
                    var additionalSLSProductJsonObj = JSON.parse(additionalSLSProductJson);
                    var additionalProductVariantSku = additionalProductJsonObj[mainSKU][coilSpringWeight];
                    var additionalSLSProductVariantSku = additionalSLSProductJsonObj[mainSKU][coilSpringWeight];
            
                    if (additionalProductMainSelectOptions.length) {
                        additionalProductMainSelectOptions.forEach(function (item) {
                            if (item.getAttribute('data-sku') == additionalSLSProductVariantSku) {
                                currentVariantId = item.closest('select option[data-sku="' + additionalSLSProductVariantSku + '"]').value;
                                currentVariantPrice = item.getAttribute('data-price');
                                currentVariantTitle = item.getAttribute('data-title');
                                currentVariantSku = additionalSLSProductVariantSku;
                                if (item.getAttribute('data-qty') == '0') {
                                    addProductsBtn.disabled = true;
                                    addProductsBtn.style.background = '#8e9091';
                                    addProductsBtn.innerHTML = 'Out of Stock';
                                }
                            }
                            if (item.getAttribute('data-sku') == additionalProductVariantSku) {
                                currentStandardVariantId = item.closest('select option[data-sku="' + additionalProductVariantSku + '"]').value;
                                currentStandardVariantPrice = item.getAttribute('data-price');
                                currentStandardVariantTitle = item.getAttribute('data-title');
                                currentStandardVariantSku = additionalProductVariantSku;
                                if (item.getAttribute('data-qty') == '0') {
                                    addStandardProductsBtn.disabled = true;
                                    addStandardProductsBtn.style.background = '#8e9091';
                                    addStandardProductsBtn.innerHTML = 'Out of Stock';
                                }
                            }
                        });
                    }
            
                    if (currentVariantSku != undefined || currentStandardVariantSku != undefined) {
                        formContainer.classList.remove('show');
                        additionalProductFinalContainer.classList.add('show');
                        additionalProductFinalContainer.querySelector('.additional_sls_product .additional-product-info-price').innerHTML = currentVariantPrice;
                        additionalProductFinalContainer.querySelector('.additional_sls_product .additional-product-info-sku').innerHTML = currentVariantSku;
                        additionalProductFinalContainer.querySelector('.additional_sls_product .additional-product-info-meta').innerHTML = currentVariantTitle;
            
                        additionalProductFinalContainer.querySelector('.additional_standard_product .additional-product-info-price').innerHTML = currentStandardVariantPrice;
                        additionalProductFinalContainer.querySelector('.additional_standard_product .additional-product-info-sku').innerHTML = currentStandardVariantSku;
                        additionalProductFinalContainer.querySelector('.additional_standard_product .additional-product-info-meta').innerHTML = currentStandardVariantTitle;
            
                        addProducts(mainId, currentVariantId, currentStandardVariantId);
                    } else {
                        document.querySelector('.additional-product-calulator-popup-wrapper .adding-error').classList.add('show');
                    }
                }
            }
            
            function getAnAdditionalProductPage(standard, stroke, weightUnit, lengthUnit, weightValue, lengthValue, mainSKU, mainId) {
                var calculate = true;
                if (calculatorInputsPage.length) {
                    calculatorInputsPage.forEach(function (item) {
                        if (item.value == '') {
                            item.classList.add('error-input');
                            item.closest('.field-item').querySelector('.error').classList.add('show');
                            calculate = false;
                        }
                    });
                }
            
                if (calculate) {
                    var coilSpringWeight,
                        currentVariantPrice,
                        currentVariantTitle,
                        currentVariantSku,
                        currentVariantId;
                    if (standard == 'Metric' || standard == 'Metric Trunnion') {
                        if (weightUnit == 'lbs' && lengthUnit == 'in') {
                            coilSpringWeight = (weightValue / 165) * 400 * (lengthValue / ((stroke / 25.4) * (stroke / 25.4)));
                        } else if (weightUnit == 'kg' && lengthUnit == 'in') {
                            coilSpringWeight = ((weightValue * 2.205) / 165) * 400 * (lengthValue / ((stroke / 25.4) * (stroke / 25.4)));
                        } else if (weightUnit == 'kg' && lengthUnit == 'mm') {
                            coilSpringWeight = ((weightValue * 2.205) / 165) * 400 * ((lengthValue / 25.4) / (((stroke / 25.4) * (stroke / 25.4))));
                        } else if (weightUnit == 'lbs' && lengthUnit == 'mm') {
                            coilSpringWeight = ((weightValue) / 165) * 400 * ((lengthValue / 25.4) / (((stroke / 25.4) * (stroke / 25.4))));
                        }
                    } else if (standard == 'Imperial') {
                        if (weightUnit == 'lbs' && lengthUnit == 'in') {
                            coilSpringWeight = (weightValue / 165) * 400 * (lengthValue / ((stroke * stroke)));
                        } else if (weightUnit == 'kg' && lengthUnit == 'in') {
                            coilSpringWeight = ((weightValue * 2.205) / 165) * 400 * (lengthValue / ((stroke * stroke)));
                        } else if (weightUnit == 'kg' && lengthUnit == 'mm') {
                            coilSpringWeight = ((weightValue * 2.205) / 165) * 400 * ((lengthValue / 25.4) / ((stroke * stroke)));
                        } else if (weightUnit == 'lbs' && lengthUnit == 'mm') {
                            coilSpringWeight = ((weightValue) / 165) * 400 * ((lengthValue / 25.4) / ((((stroke * stroke)))));
                        }
                    }
            
                    coilSpringWeight = Math.round(coilSpringWeight / 50) * 50;
                    var additionalProductJsonObj = JSON.parse(additionalProductJson);
                    var additionalProductVariantSku = additionalProductJsonObj[mainSKU][coilSpringWeight];
            
                    if (additionalProductMainSelectOptions.length) {
                        additionalProductMainSelectOptions.forEach(function (item) {
                            if (item.getAttribute('data-sku') == additionalProductVariantSku) {
                                currentVariantId = item.closest('select option[data-sku="' + additionalProductVariantSku + '"]').value;
                                currentVariantPrice = item.getAttribute('data-price');
                                currentVariantTitle = item.getAttribute('data-title');
                                currentVariantSku = additionalProductVariantSku;
                            }
                        });
                    }
            
                    if (currentVariantSku != undefined) {
                        formContainerPage.classList.add('show');
                        additionalProductFinalContainerPage.querySelector('.additional-product-info-price').innerHTML = currentVariantPrice;
                        additionalProductFinalContainerPage.querySelector('.additional-product-info-sku').innerHTML = currentVariantSku;
                        additionalProductFinalContainerPage.querySelector('.additional-product-info-meta').innerHTML = currentVariantTitle;
            
                        addProductsPage(mainId, currentVariantId);
                        document.querySelector('.page-additional-product-calculator .adding-error').classList.remove('show');
                    } else {
                        document.querySelector('.page-additional-product-calculator .adding-error').classList.add('show');
                    }
                }
            }
            
            function addProducts(mainId, currentVariantId, currentStandardVariantId) {
                addProductsBtn.addEventListener('click', function () {
                    push_to_queue(currentVariantId, 1, {}, Shopify.moveAlong);
                    // push_to_queue(mainId, 1, {}, Shopify.moveAlong);
                });
                addStandardProductsBtn.addEventListener('click', function () {
                    push_to_queue(currentStandardVariantId, 1, {}, Shopify.moveAlong);
                    // push_to_queue(mainId, 1, {}, Shopify.moveAlong);
                });
            }
            
            function addProductsPage(mainId, currentVariantId) {
                addProductsBtnPage.addEventListener('click', function () {
                    push_to_queue(currentVariantId, 1, {}, Shopify.moveAlong);
                    push_to_queue(mainId, 1, {});
                });
            }
            
            Shopify.moveAlong = function () {
                if (Shopify.queue.length) {
                    var request = Shopify.queue.shift();
                    Shopify.addItem(request.variantId, request.quantity, request.properties, Shopify.moveAlong);
                }
                else {
                    document.location.href = '/cart';
                }
            };
            
            Shopify.addItem = function (id, qty, properties, callback) {
                var params = {
                    quantity: qty,
                    id: id
                };
                if (properties != false) {
                    params.properties = properties;
                }

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(params)
                })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        return response.json(); // Assuming the response is in JSON format
                    })
                    .then(data => {
                        if (typeof callback === 'function') {
                            callback(data);
                        }
                    })
                    .catch(error => {
                        console.error('There has been a problem with your fetch operation:', error);
                    });
            };
            
            function push_to_queue(variantID, quantity, properties, callback) {
                Shopify.queue.push({
                    variantId: variantID,
                    quantity: quantity,
                    properties: properties
                });
                if (typeof callback === 'function') {
                    callback();
                }
            };

            // END SPRING RATE CALCULATOR
            
            // Loop through all ATC forms, in case quick ATC is present in product cards.
            const addToCartForms = document.querySelectorAll(_config.addToCartFormSelector);
            
            addToCartForms.forEach((addToCartForm) => {
                
                if ( addToCartForm.dataset.isAjax == 'true' ) {

                    addToCartForm.addEventListener('submit', function(e){
                        e.preventDefault();

                        // Remove error message
                        addToCartForm.querySelector('.cart__message--error').textContent = '';

                        const addToCartBtn      = addToCartForm.querySelector(_config.addToCartBtnSelector),
                            addToCartText       = addToCartForm.querySelector('[data-add-to-cart-text]'),
                            addToCartTextSticky = addToCartForm.querySelector('[data-add-to-cart-text-sticky]'),
                            addToCartBtnCard    = addToCartForm.querySelector('.quick-cart-add__loader'),
                            addToCartType       = addToCartForm.dataset.AddCartType;

                        // Get current label to reapply after cart submitted
                        _config.addToCartBtnLabel = addToCartText.textContent;

                        if (document.body.classList.contains('template-product') && addToCartForm.classList.contains('quick-cart-add__product-hero')) {
                            _setText(addToCartText, _config.addingToCartBtnLabel);
                            _setText(addToCartTextSticky, _config.addingToCartBtnLabel);
                        } else if (addToCartForm.getAttribute('data-add-cart-type') == 'modal') { // Cart Modal case
                            // Change Button Text to indicate that product is adding to cart
                            _setText(addToCartText, _config.addingToCartBtnLabel);
                            addToCartBtn.classList.add('disabled');
                            addToCartBtn.disabled = true;
                            addToCartBtn.classList.add('button--active');
                        } else {
                            _setText(addToCartBtnCard, _config.addingToCartBtnLabel);
                        }

                        // Add to cart.              
                        const formData = new FormData(addToCartForm);
                        
                        // Objectify Form Input data
                        let formObject = {};
                        formData.forEach((value, key) => {
                            if(!Reflect.has(formObject, key)){
                                formObject[key] = value;
                                return;
                            }
                            if(!Array.isArray(formObject[key])){
                                formObject[key] = [formObject[key]];    
                            }
                            formObject[key].push(value);
                        });
                        
                        // Required Shopify Format for Form payload
                        const formPayload = {
                            'items': [formObject]
                        }; 

                        fetch(_config.shopifyAjaxAddURL, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(formPayload)
                        })
                            .then((response) => {
                                if(response.status!==200) {
                                    throw response;
                                } else {
                                    return response.json();
                                }
                            })
                            .then((jsonResponse) => {
                                const itemData = jsonResponse.items[0];
                          
                                addToCartBtnCard?.classList.add('button--active');
                            
                                if (addToCartForm.getAttribute('data-add-cart-type') == 'modal') {
                                // Update mini cart
                                    Shopify.miniCart().init();

                                    // Update free shipping progress
                                    Shopify.freeShippingProgress().init();
                                }

                                if (document.body.classList.contains('template-product') && addToCartForm.classList.contains('quick-cart-add__product-hero')) {
                                    _setText(addToCartText, _config.addedToCartBtnLabel);
                                    addToCartBtn.classList.add('disabled');
                                    addToCartBtn.disabled = true;
                                    addToCartBtn.classList.add('button--active');
                                } else {
                                    _setText(addToCartBtnCard, _config.addedToCartBtnLabel);
                                }

                                window.setTimeout(function(){

                                    addToCartBtnCard?.classList.remove('button--active');
                                    addToCartBtn.classList.remove('button--active');
                                    addToCartBtn.classList.remove('disabled');
                                    addToCartBtn.disabled = false;

                                    if (document.body.classList.contains('template-product') && addToCartForm.classList.contains('quick-cart-add__product-hero')) {
                                        _setText(addToCartText, _config.addToCartBtnLabel);
                                    } else if (addToCartForm.getAttribute('data-add-cart-type') == 'modal') { // Cart Modal case
                                        _setText(addToCartText, _config.addToCartBtnLabel);

                                        // If the PDP has "spring-shock" template aka has spring rate calculator, open the calculator popup instead of the cart confirmation modal
                                        if (addToCartForm.classList.contains('product-form--single-shocks')) {
                    
                                            var currentOption = addToCartForm.querySelector('[name="id"]');
                                            optionStandard = currentOption.options[currentOption.selectedIndex].getAttribute('data-option-1');
                                            optionStroke = currentOption.options[currentOption.selectedIndex].getAttribute('data-option-2').split('x')[1];
                                            mainSKU = currentOption.options[currentOption.selectedIndex].getAttribute('data-sku');
                                            mainId = currentOption.value;
                                            openAdditionalProductPopup(optionStandard, optionStroke, mainSKU, mainId);
                                        } else {
                                            // Open the cart confirmation modal
                                            _showFeedback(itemData);

                                            // ---------------------------------------------
                                            // Trap Focus inside the Cart Confirmation Modal
                                            // ---------------------------------------------

                                            // add all the elements inside modal which you want to make focusable
                                            const  focusableElements    = '[tabindex]:not([tabindex="-1"]), [href], button';
                                            const modal                 = document.querySelector('#modal_cart_confirmation'); // select the modal by it's id
                                            const firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
                                            const focusableContent      = modal.querySelectorAll(focusableElements);
                                            const lastFocusableElement  = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

                                            document.addEventListener('keydown', function(e) {
                                                let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

                                                if (!isTabPressed) {
                                                    return;
                                                }

                                                if (e.shiftKey) { // if shift key pressed for shift + tab combination

                                                    if (document.activeElement === firstFocusableElement) {

                                                        lastFocusableElement.focus(); // add focus for the last focusable element
                                                        e.preventDefault();
                                                    }
                                                } else { // if tab key is pressed

                                                    if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab

                                                        firstFocusableElement.focus(); // add focus for the first focusable element
                                                        e.preventDefault();
                                                    }
                                                }
                                            });
                                        }
                                    }
                                }, _config.howLongTillBtnReturnsToNormal);

                                // Update cart count
                                fetch(_config.shopifyAjaxCartURL, {
                                    cache: 'no-cache',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    }
                                })
                                    .then((response) => response.json())
                                    .then((cart) => {
                                        const cartCountSelector = document.querySelectorAll(_config.cartCountSelector);
                                
                                        if (cartCountSelector && cartCountSelector.length > 0) {
                                            cartCountSelector.forEach((cartCount) => {
                                                cartCount.textContent = cart.item_count;
                                            }); 
                                        }
                                    });
                            })
                            .catch(async (error) => {
                                try {
                                    const errorObject = await error.json();
                                    if (errorObject?.description) {
                                        const errorDescription = errorObject.description;
                                    
                                        if (errorDescription.slice(0,4) === 'All ') {
                                            document.querySelector('.cart__message--error').textContent = "You can't add more of this product to the cart.";
                                            _setText(addToCartText, _config.soldOutBtnLabel);
                                            addToCartBtn.disabled = true;
                                            return;
                                        } else {
                                            document.querySelector('.cart__message--error').textContent = errorDescription;
                                            addToCartBtn.disabled = false;
                                            addToCartBtn.classList.remove('disabled');
                                            _setText(addToCartText, _config.addToCartBtnLabel);
                                            return;
                                        }
                                    } 
                                } catch {
                                    console.error(error);
                                }
                            
                            });
                        return false;
                    });
                }
            });
        };
        return {
            init: (params) => {
                // Configuration
                params = params || {};
                // Merging with defaults.
                Object.assign(_config, params);
                // Action
                _init();
            },
            getConfig: () => {
                return _config;
            }
        };
    };
    Shopify.AjaxifyCart().init();
});
